import PropTypes from 'prop-types';
import React from "react";
import cx from "classnames";
import {
  InputGroup,
  FormControl,
  Button,
  Row,
  Col,
} from "react-bootstrap";

import buildUrl from "build-url-ts";


import PlaceholderEmptyMessage from "../../../components/PlaceholderEmptyMessage";
import RolodexEmptyMessageSvgIcon from "src/legacy/images/rolodexEmptyMessage.svg";

import userRoleService from "src/services/userRoles.service.js";

import ContactListContainer from "./lists/ContactListContainer";
import ContactListDetailsContainer from "./details/ContactListDetailsContainer.jsx";
import ContactListFormContainer from "./forms/ContactListFormContainer.jsx";
import { localizedStrings } from 'src/localization';

import styles from "./Styles.module.scss";
import Slider from 'src/components/slider';
import Actions from 'src/components/actionbar';

class DistributionListView extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      query: "",
      contactFormView: false,
      createContact: true,
      contactListView: false,
      showDeleteConfirmation: false,
      isGlobalListView: false,
      resetView: false
    };
    this._handleCreateClick = this._handleCreateClick.bind(this);
    this._handleNextClick = this._handleNextClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);
    this._handleSearchQueryChange = this._handleSearchQueryChange.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this._handleAddContactsClick = this._handleAddContactsClick.bind(this);
    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    this._handleClearClick = this._handleClearClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedDistributionList = this.localizatedSettings.distribution_lists;
  }

  _handleAddContactsClick() {
    this.setState({
      createContact: false,
      contactFormView: true,
      contactListView: true,
    });
  }

  _handleNextClick() {
    this.setState({
      contactListView: true
    });
  }

  _handleCreateClick() {
    this.setState({
      contactFormView: true,
    });
  }

  _handleCancelClick() {
    this.setState({
      contactListView: false,
      contactFormView: false,
    });
  }

  _handleSearchQueryChange(e) {
    this.setState({
      query: e.target.value,
    });
  }

  _handleSearch(event) {
    event.preventDefault();

    var queryParams = {};
    if (this.state.query) {
      queryParams["query"] = this.state.query;
    }

    if (this.props.location.query.global) {
      queryParams["global"] = this.props.location.query.global;
    }

    var path = buildUrl(null, {
      path: this.props.location.pathname,
      queryParams: queryParams,
    });

    console.log(path);
    
    this.props.navigate(path);
  }
  
  _handleClearClick(){
    this.setState({
      query : ""
    } , () => {
      var queryParams = {};

    var path = buildUrl(null, {
      path: this.props.location.pathname,
      queryParams: queryParams,
    });
    this.props.navigate(path);

    })
  }

  _renderDistributionEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title="Where is everybody?"
        message="Add to your contacts to start tracking engagement and enhancing your conversations."
        image={RolodexEmptyMessageSvgIcon}
        className={styles.emptyMessage}
        buttonText="Create now"
        onClick={this._handleCreateClick}
        visible={true}
      />
    );
  }

  handleBackButtonClick(){
    this.setState({
      contactFormView: true,
      contactListView: false
    })
  }

  componentDidMount() {

    this.props.fetchReportSummary();

    this.setState({
      isGlobalListView:
        this.props.globalContactsEnabled &&
        (this.props.location.query["global"] || false),
    });

    var query = this.props.location.query["query"] || "";
    if (query) {
      this.setState({
        query: query,
      });
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   var query = nextProps.location.query["query"] || "";
  //   if (query) {
  //     this.setState({
  //       query: query,
  //     });
  //   }
  // }

  render() {
    return (
      <div className={styles.content}>
        <div className={styles.headerRow}>
        <h3 className={styles.heading}>{this.localizedDistributionList.title}</h3>
        {userRoleService.canCreateContact() && (
            <Actions.Button width={3} icon={'paperflite-add'} title='Create new list'   onClick={this._handleCreateClick} />
            )}
        </div>
        <Row>
          <Col md={4} 
            lg={4}
            xl={4}
          className={styles.menus}>

            {userRoleService.canAccessSearch() && (
              <form className={styles.search} onSubmit={this._handleSearch}>
                  <InputGroup className={styles.inputGroup}>
                    <InputGroup.Text className={styles.addon}>
                      <span
                        className={cx(styles.icon, "paperflite-search")}
                      ></span>
                    </InputGroup.Text>
                    <FormControl
                      type="text"
                      placeholder={this.localizedDistributionList.search_placeholder}
                      value={this.state.query}
                      onChange={this._handleSearchQueryChange}
                    />
                    <InputGroup.Text>
                      {this.state.query.length > 0 &&
                      (<i className={cx('paperflite-close', styles.closeIcon)} onClick={() => this._handleClearClick()}></i> )}
                    </InputGroup.Text>
                  </InputGroup>
              </form>
            )}
            <ContactListContainer
              location={this.props.location}
              params={this.props.params}
            />
          </Col>
          <Col
            md={8}
            lg={8}
            xl={8}
            className={styles.menuDetails}
            style={{ height: this.state.height }}
          >
            <ContactListDetailsContainer
              id={this.props.params.id}
              onAddContactsClick={this._handleAddContactsClick}
              onCreateDistributionClick={this._handleCreateClick}
              trial={this.props.trial}
            />
          </Col>
        </Row>

        <Slider.Dialog width="28vw" show={this.state.contactFormView}>
        <ContactListFormContainer
            store={this.context.store}
            id={
              this.state.createContact
                ? null
                : this.props.contactList && this.props.contactList.id
            }
            onCancelClick={this._handleCancelClick}
            onNextClick={this._handleNextClick}
            contactListView={this.state.contactListView}
            createView={this.state.contactFormView}
            isResetView={this.state.resetView}
            location={this.props.location}
            handleBackButtonClick = {this.handleBackButtonClick}
          />
        </Slider.Dialog>
      </div>
    );
  }
}
export default DistributionListView;
